import React, { SVGProps } from 'react'
const SvgChevronDownLoD = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill="#FFF"
      d="M12 14.94 6.53 9.47a.75.75 0 1 0-1.06 1.06l6 6a.75.75 0 0 0 1.06 0l6-6a.75.75 0 0 0-1.06-1.06L12 14.94Z"
    />
  </svg>
)
export default SvgChevronDownLoD
